import React from "react"
import { useCookies } from "react-cookie"

import styles from "./RejectCookiesButton.module.scss"
import { Button } from "../ui/button"
import { removeCookies } from "util/hasCookieConsent"

export const RejectCookiesButton: React.FC = () => {
  const [cookies, setCookie] = useCookies(["CookieConsent"])

  const hasConsent =
    cookies.CookieConsent === false || cookies.CookieConsent === undefined ? false : true

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const cookieOptions: any = {
    path: "/",
    maxAge: 365 * 24 * 60 * 60,
    sameSite: "lax",
  }

  if (process.env.NODE_ENV === "production") {
    cookieOptions.domain = `.${process.env.NEXT_PUBLIC_DOMAIN}`
  }

  const handleOptIn = () => {
    setCookie("CookieConsent", "true", cookieOptions)
    window.location.reload()
  }

  const handleOptOut = () => {
    removeCookies()
  }

  return (
    <div className={styles.container}>
      <p>
        We only collect cookies to improve our education and we don&apos;t sell your information.{" "}
        {hasConsent
          ? "Withdraw consent to opt out of tracking."
          : "Accept cookies to opt in of tracking."}{" "}
        You can always change your mind later.
      </p>
      <span>Current cookies status: {hasConsent ? "Tracking" : "No tracking"}</span>
      <div className={styles.footer}>
        {!hasConsent ? (
          <Button className={styles.button} underline onClick={handleOptIn}>
            Accept cookies
          </Button>
        ) : (
          <Button className={styles.button} underline onClick={handleOptOut}>
            Withdraw consent
          </Button>
        )}
      </div>
    </div>
  )
}
